export default "__VITE_ASSET__CSZVemUQ__"